import { useEffect, useState } from 'react';
import { onValue, ref } from 'firebase/database';
import { rtdb } from '../firebase';
import { useEstablishmentAuth } from '../context/EstablishmentAuthContext';

/**
 * Live list of CROUS accessible to the signed-in admin.
 *
 * Filtering:
 *  - role === 'super'         → all crous in RTDB
 *  - role === 'establishment' → only crous whose id is in adminDoc.crousIds
 */

function sortAlpha(a, b) {
  return (a.name || a.id).localeCompare(b.name || b.id, 'fr');
}

export default function useManagedCrous() {
  const { adminDoc, status } = useEstablishmentAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (status !== 'authorized') {
      setItems([]);
      setLoading(false);
      return undefined;
    }

    const isSuper = adminDoc.role === 'super';
    const allowedIds = !isSuper && adminDoc.crousIds ? Object.keys(adminDoc.crousIds) : null;

    const r = ref(rtdb, 'crous');
    return onValue(
      r,
      (snap) => {
        const val = snap.val() || {};
        const list = Object.entries(val)
          .map(([id, data]) => ({ id, ...(data || {}) }))
          .filter((c) => (isSuper ? true : allowedIds && allowedIds.includes(c.id)));
        list.sort(sortAlpha);
        setItems(list);
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );
  }, [status, adminDoc]);

  return { items, loading, error };
}
